module.exports = __webpack_public_path__ + "img/T2C_xs_02.452f0d0e.png";